// Port of api/fuel/app/classes/filter/core/common/valid.php
// Validation trait for filter/sort units - checks owner type, source, cache exclusions
export default {
	valid: function(config, filter, unit) {
		var packageType = config && config.packageType
		var resultType = config && config.resultType
		var ownerType = config && config.ownerType
		var cacheType = config && config.cacheType
		var source = filter && filter.source ? filter.source : {}
		var hasPackageType = packageType !== undefined && packageType !== null
		var hasResultType = resultType !== undefined && resultType !== null

		if (unit._package_exclude && hasPackageType) {
			for (var pex = 0; pex < unit._package_exclude.length; pex++) {
				if (packageType.indexOf(unit._package_exclude[pex]) !== -1) return false
			}
		}
		if (unit._package_require) {
			if (!hasPackageType) return false
			for (var prq = 0; prq < unit._package_require.length; prq++) {
				if (packageType.indexOf(unit._package_require[prq]) === -1) return false
			}
		}
		if (unit._result_exclude && hasResultType) {
			for (var rex = 0; rex < unit._result_exclude.length; rex++) {
				if (resultType.indexOf && resultType.indexOf(unit._result_exclude[rex]) !== -1) return false
				if (resultType === unit._result_exclude[rex]) return false
			}
		}
		if (unit._result_require) {
			if (!hasResultType) return false
			for (var rrq = 0; rrq < unit._result_require.length; rrq++) {
				if (resultType.indexOf) {
					if (resultType.indexOf(unit._result_require[rrq]) === -1) return false
				} else if (resultType !== unit._result_require[rrq]) {
					return false
				}
			}
		}
		if (unit._owner_exclude && unit._owner_exclude.indexOf(ownerType) !== -1) return false
		if (unit._owner_require && unit._owner_require.indexOf(ownerType) === -1) return false
		if (unit._source_require) {
			for (var i = 0; i < unit._source_require.length; i++) {
				if (!source[unit._source_require[i]]) return false
			}
		}
		if (unit._source_exclude) {
			for (var j = 0; j < unit._source_exclude.length; j++) {
				if (source[unit._source_exclude[j]]) return false
			}
		}
		if (unit._cache_exclude && unit._cache_exclude.indexOf(cacheType) !== -1) return false
		if (unit._cache_require && unit._cache_require.indexOf(cacheType) === -1) return false
		return true
	}
}
